import styled from 'styled-components';
export const Overlay = styled.div`
    display: flex;
    position: fixed !important;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'} !important;
    -webkit-transform: ${({ open }) => open && 'translate3d(0,0,0)'} !important; 
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100%;
    z-index: 8 !important;
    background-color: ${({ open }) => open ? 'rgba(0,0,0,.2)' : 'transparent'} !important;
    transition: opacity 0.2s ease-in-out;
    -webkit-transition: opacity 0.2s ease-in-out;
    -moz-transition: opacity 0.2s ease-in-out;
    -ms-transition: opacity 0.2s ease-in-out;
    -o-transition: opacity 0.2s ease-in-out;
    opacity: ${({ open }) => open ? '1' : '0'};
`
export const Container = styled.ul`
    overflow: visible;
    -webkit-overflow-scrolling: auto !important;
    overflow-x: hidden;
    list-style: none;
    display: flex;
    flex-flow: column nowrap;
    background-color: #fff;
    position: fixed !important;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'} !important;
    -webkit-transform: ${({ open }) => open && 'translate3d(0,0,0)' } !important; 
    top: 0;
    right: 0;
    bottom: 0;
    max-height: 100vh;
    width: 100%;
    max-width: 360px;
    margin: 0px;
    padding: 0px;
    padding-top: 129px;
    z-index: 8 !important;
    transition: transform 0.2s ease-in-out;
    -webkit-transition: 0.2s ease-in-out;
    /* box-shadow: ${({ open }) => open ? '0 4px 490px 0px rgba(0,0,0,.2)' : 'none'}; */

    /* ::-webkit-scrollbar {
        display: none;
    } */

    button {
        background-color: transparent;
        width: 24px;
        height: 24px;
        padding: 0;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        justify-content: center;
        align-self: flex-end;
        margin: 16px;
        margin-right: 24px;
        box-sizing: border-box;

        :focus {
            opacity: 0.5
        }
        
        .i-close {
            vertical-align: middle;
            align-self: center;
            padding: 0;
            font-size: 26px;
        }
    }

    li {
        vertical-align: middle;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 24px;
        margin-bottom: 64px;

        :hover {
            opacity: 0.5
        }

        h5 {
            margin: 0;
            padding: 0;
            padding-top: 2px;
            color: #2a0709;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 550;
        }

        .icones {
                vertical-align: middle;
                font-size: 16px;
                margin-right: 16px;
                object-fit: contain;

                /* @media (max-width: 360px) {
                    width: 14.7px;
                    height: 14.7px;
                } */
            }
    }
`